import { debounce } from 'throttle-debounce';
import Events from '@/scripts/lib/Events';

export default class SearchForm {
   /** @type {Events<'change'>} */
   events = new Events;

   /** @param {HTMLElement} root */
   constructor(root, { query = '' }) {
      this.$root = root;
      this._query = query;

      this._init();
   }

   _init() {
      this._getElements();
      this._updateForm();
      this._initEvents();
   }

   focus() {
      this.$query.focus();
   }

   _initEvents() {
      this.$root.addEventListener('submit', (e) => {
         e.preventDefault();
         this._setValue(this.$query.value);
      });

      this.$root.addEventListener('reset', (e) => {
         e.preventDefault();
         this._reset();
      });

      this.$query.addEventListener('input', debounce(250, () => {
         this._setValue(this.$query.value);
      }));
   }

   _updateForm() {
      this.$query.value = this._query;
   }

   _reset() {
      this._setValue('');
      this._updateForm();
      this.$query.focus();
   }

   _setValue(value) {
      const query = this._prepareQuery(value);
      if (query === this._query) return;

      this._query = query;
      this.events.emit('change', this._query);
   }

   /** @param {string} query */
   _prepareQuery(query) {
      return query.trim().replace(/'/g, '’');
   }

   _getElements() {
      this.$query = this.$root.querySelector('.search-query-js');
   }

   get query() {
      return this._query;
   }

   set query(value) {
      this._setValue(value);
      this._updateForm();
   }
}